import React from 'react';
import ServicePage from '../components/services/ServicePage';
import featherFlags from '../data/services/feather-flags';

const FeatherFlags: React.FC = () => <ServicePage data={featherFlags} />;

export default FeatherFlags;
